/**
 * loginActions.js
 * Created by michaelbray on 2/13/18.
 */

import axios from 'axios';
import {
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    LOCKOUT,
    LOGIN_BAD_MAGIC,
    LOGOUT_SUCCESS,
    HIDE_LOGIN_MODAL,
    MFA_REQUIRED,
    SHOW_LOGIN_MODAL,
    SHOW_SIGN_IN_GUEST_MODAL,
    HIDE_SIGN_IN_GUEST_MODAL,
    ACCOUNT_SERVICE_STATUS_UPDATED,
    SHOW_CREATE_ACCOUNT_MODAL,
    HIDE_CREATE_ACCOUNT_MODAL,
    SHOW_RESET_MODAL,
    HIDE_RESET_MODAL
} from '../../actions/actionTypes';

import LocalStorage from '../../helpers/storage/LocalStorage';
import SessionStorage from '../../helpers/storage/SessionStorage';

const loginSucceeded = (profile) => ({
    type: LOGIN_SUCCESS,
    profile
});

const loginFailed = () => ({
    type: LOGIN_FAILED
});

const lockout = () => ({
    type: LOCKOUT
});

const loginBadMagic = () => ({
    type: LOGIN_BAD_MAGIC
});

const logoutSucceeded = () => ({
    type: LOGOUT_SUCCESS
});

const mfaRequired = () => ({
    type: MFA_REQUIRED
});

const serviceStatusUpdated = (enabled, announcement, loginNotice) => ({
    type: ACCOUNT_SERVICE_STATUS_UPDATED,
    enabled,
    announcement,
    loginNotice
});

export const login = (loginData) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/login`;
            const response = await axios.post(url, loginData);
            const profile = response.data;
            LocalStorage.setItem('recaccount', JSON.stringify(profile));

            if (window.dataLayer) {
                window.dataLayer.push({
                    userID: profile.account.account_id
                });
            }

            const { redirectUrl } = loginData;

            dispatch(loginSucceeded(profile));
            if (redirectUrl) {
                window.location.replace(redirectUrl);
            }
        }
        catch (error) {
            if (error.response && error.response.data && error.response.data.error === 'mfa') {
                dispatch(mfaRequired());
            }
            else if (error.response && error.response.data && error.response.data.error === 'lockout') {
                dispatch(lockout());
            }
            else {
                dispatch(loginFailed());
            }
        }
    };
};


export const magicLogin = (magicID) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/login/magic/${magicID}`;
            const response = await axios.get(url);
            const profile = response.data;
            localStorage.setItem('recaccount', JSON.stringify(profile));

            if (window.dataLayer) {
                window.dataLayer.push({
                    userID: profile.account.account_id
                });
            }

            dispatch(loginSucceeded(profile));
        }
        catch (error) {
            if (error.response && error.response.data && error.response.data.error === 'badmagic') {
                dispatch(loginBadMagic());
            }
            else {
                dispatch(loginFailed());
            }
        }
    }
}

export const guestLogin = () => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/guest/login`;
            const response = await axios.post(url, {});
            const profile = response.data;
            LocalStorage.setItem('recaccount', JSON.stringify(profile));

            if (window.dataLayer) {
                window.dataLayer.push({
                    userID: profile.account.account_id
                });
            }

            dispatch(loginSucceeded(profile));
        }
        catch (error) {
            dispatch(loginFailed());
        }
    };
};

export const loggedIn = (profileData) => {
    return (dispatch) => {
        dispatch(loginSucceeded(profileData));
    };
};

export const logout = () => {
    return (dispatch) => {
        LocalStorage.clear();
        SessionStorage.clear();
        dispatch(logoutSucceeded());
        window.location.assign("/");
    };
};

export const clearShowLoginModal = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_LOGIN_MODAL
        });
    };
};

export const showLoginModal = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_LOGIN_MODAL
        });
    };
};

export const showSignInGuestModal = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_SIGN_IN_GUEST_MODAL
        });
    };
};

export const clearShowSignInGuestModal = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_SIGN_IN_GUEST_MODAL
        });
    };
};

export const showCreateAccountModal = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_CREATE_ACCOUNT_MODAL
        });
    };
};

export const clearShowCreateAccountModal = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_CREATE_ACCOUNT_MODAL
        });
    };
};

export const showResetModal = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_RESET_MODAL
        });
    };
};

export const clearShowResetModal = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_RESET_MODAL
        });
    };
}; 

export const updateAccountServiceStatus = () => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/status`;
            const response = await axios.get(url);

            const enabled = response.data.enabled;
            
            // COMMENT OUT THE LINES BELOW TO TEST THE ANNOUNCEMENT
            const announcement = response.data.announcement;

            // UNCOMMENT THE LINE BELOW TO TEST ANNOUNCEMENT
            //const announcement = {
            //    banner_title: "WEBSITE MAINTENANCE NOTICE",
            //    banner_body: "%3Cp%3EPlease%20be%20aware%20starting%20at%2011%20pm%20ET%20on%20October%2026%2C%202019%2C%20Recreation.gov%20will%20conduct%20system%20maintenance.%20During%20this%20time%2C%20some%20parts%20of%20Recreation.gov%20may%20be%20not%20available%20including%20Help%20Center%20articles.%20Additionally%2C%20the%20Recreation.gov%20Call%20Center%20may%20be%20temporarily%20closed.%20The%20Call%20Center%20will%20open%20at%2010%20AM%20ET%20on%20October%2027%2C%202019.%3C%2Fp%3E",
            //    banner_body_color: "dark",
            //    banner_background_color: "light",
            //    banner_enable_hiding: true,
            //    banner_enabled: true,
            //    banner_homepage_only: false,
            //    banner_image: "/img/announcements/site_maintenance_background.jpg",
            //    banner_key: "maintenance_dev_key",
            //    banner_link: "",
            //    banner_link_button_title: ""
            //}

            
            // COMMENT OUT THE LINE BELOW TO TEST THE LOG IN NOTICE
            const loginNotice = response.data.login_notice;

            // UNCOMMENT THE LINES BELOW TO TEST THE LOG IN NOTICE
             //const loginNotice = {
             //    notice_body: "%3Cp%20class%3D%22something%22%3EHello%2C%20World!%3C%2Fp%3E",
             //    notice_enabled: true,
             //    notice_title: ""
             //};

            dispatch(serviceStatusUpdated(enabled, announcement, loginNotice));
        }
        catch (error) {
            dispatch(serviceStatusUpdated(true, { banner_enabled: false }, { notice_enabled: false }));
        }
    };
};
